import { SET_FIRST } from './appReducers';

export function firstAccess() {
    return dispatch => {
        dispatch({
            type: SET_FIRST
        });
    }
}
